<div
  class="flex items-center max-w-full h-[52px] border rounded-lg border-[#ADB0C2] bg-white px-6"
>
  <i class="fas fa-search text-[#ADB0C2] text-lg mr-4"></i>
  <input
    type="text"
    placeholder="Search..."
    [(ngModel)]="searchTerm"
    (ngModelChange)="onSearchChange()"
    class="w-full h-full border-none focus:outline-none text-[#07073C] text-sm bg-transparent placeholder-[#07073C]"
  />
</div>
